import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './Services.css';
import Divider from './../Divider/Divider';


const Services = () => {
  return (
    <div className="services_grid_container">
    <h1 class="title" style={{color:'#000000',textAlign:'center'}}> HighLights </h1>
    <Divider/>
    <div className='services_grid'>
    <div class="services color-2">
    
    
        <h6>TRENDING TECHS </h6>
        <p>
          Updating my skills to align with trending technologies
          </p>
      </div>
   
    <div class="services">
  
    <h6>MULTI PLATFORMS </h6>
        <p>
        Hands-on Experience in developing MultiPlatform  Apps.
        </p>
      </div>
   
    <div class="services color-4">
   
     
    <h6>SOURCE CONTROL </h6>
        <p>
        All Projects source codes are appropriately managed using source control.
        </p>
      </div>
   
      <div class="services">
     
      <h6> CODING STANDARDS</h6>
        <p>
        All codes are developed to meet industry standards
        </p>
      </div>

      <div class="services color-4">
      
      <h6>E2E DEVELOPER </h6>
        <p>
        Skilled to handle End to End development in most platforms.
        </p>
      </div>

      <div class="services color-5">
     
      <h6>TEAM PLAYER </h6>
        <p>
        Exposure to working with fulltime/remote and multi-cultured team projects.
        </p>
      </div>
    
    </div>    
    </div>
  );
};

export default Services;
